var {AmpersandModel} = require('catalog/libs');

var HPEServices = require('../../base/hpe.services');
var HPEConstants = require('../../base/hpe.constants');

var CompareTrayItemCollection = require('./item/hpe.catalog.comparetray.item.model');

/**
 * Product Catalog Compare Tray Model
 */
module.exports = AmpersandModel.extend({

    /**
     * initialization
     */
    initialize: function() {

        //event listeners
        this.on('change:isOpen', this.onIsOpenChange);
        this.on('change:isFixed', this.onIsFixedChange);
    },

    /**
     * properties
     */
    props: {
        i18n: 'object',
        isInited: ['boolean', false, false],
        isEntitled: ['boolean', false, false],
        isFixed: ['boolean', false, false],
        isMobile: ['boolean', false, false],
        isScrollTick: ['boolean', false, false],
        isOpening: ['boolean', false, false],
        isClosing: ['boolean', false, false],
        isPDPInstance: ['boolean', false, false],
        pdpTabID: 'string',
        itemCount: ['number', false, 0]
    },

    /**
     * properties
     */
    derived: {
        isOpen: {
            deps: ['itemCount', 'isInited', 'isEntitled'],
            fn: function() {
                return !!((this.itemCount > 0) && this.isInited && this.isEntitled);
            }
        },
        summaryDescriptor: {
            deps: ['itemCount'],
            fn: function() {
                return (this.itemCount === 1) ? this.i18n.item : this.i18n.items;
            }
        }
    },

    /**
     * collections
     */
    collections: {
        items: CompareTrayItemCollection
    },

    /**
     * add an item to the compare tray list
     * @param {object} item object with values
     */
    itemAdd: function(item) {

        if (item) {

            //supplement item with prop for UI animation
            item.added = true;

            //add translated label values
            item.i18n = this.i18n;

            //add new item to list
            this.items.add(item);

            //update model item count
            this.itemCount = this.items.length;

            //broadcast update event for UI updates/recalculation
            HPEServices.publish(HPEConstants.catalog.COMPARE_TRAY_UPDATED);
        }
    },

    /**
     * remove an item from the compare tray list
     * @param {string} oid id of the item to remove
     */
    itemRemove: function(oid) {

        if (oid) {

            //remove the item from the model
            this.items.remove(oid);

            //update model item count
            this.itemCount = this.items.length;

            //broadcast update event for UI updates/recalculation
            HPEServices.publish(HPEConstants.catalog.COMPARE_TRAY_UPDATED);
        }
    },

    /**
     * set the remove flag for the passed item to visually remove the item from tray;
     * this triggers CSS transition on whose end fires a list remove event --
     * this event then prompts the actual data removal of item from the tray list + compare list
     * @param {string} oid of the item to remove
     */
    setItemRemoveFromUIFlag: function(oid) {

        var item;

        //set the remove bit on the passed item to start remove animation
        if (oid) {

            item = this.items.get(oid);

            //no animation to wait for in mobile view
            if (item) {
                if (this.isMobile) {
                    item.remove();
                } else {
                    item.removed = true;
                }
            }
        }
    },

    /**
     * remove all items from compare tray list
     */
    removeAll: function() {

        var i;
        var that = this;
        var count = this.itemCount - 1;

        //set the remove bit for each item in compare tray unless if mobile remove immediately
        for (i = count; i >= 0; i--) {
            if (that.isMobile) {
                this.items.at(i).remove();
            } else {
                this.setItemRemoveFromUIFlag(this.items.at(i).oid);
            }
        }

        //broadcast update event for UI updates/recalculation
        HPEServices.publish(HPEConstants.catalog.COMPARE_TRAY_UPDATED);
    },

    /**
     * handle isOpen prop change event
     */
    onIsOpenChange: function() {

        //isOpening and isClosing each bound to CSS class,
        //each used for contextual CSS transition behavior
        if (this.isFixed) {
            if (this.isOpen) {
                this.isOpening = true;
                this.isClosing = false;
            } else {
                this.isOpening = false;
                this.isClosing = true;
            }
        } else {
            this.isOpening = false;
            this.isClosing = false;
        }
    },

    /**
     * handle isFixed prop change event
     */
    onIsFixedChange: function() {
        if (!this.isFixed) {
            this.isOpening = false;
            this.isClosing = false;
        }
    }
});
